import React, { memo } from 'react';
import { GoogleLogin } from 'react-google-login';
import { useLocale } from '@redlink/assets/locale';
import { Button } from '@redlink/components/molecules';
import { IconGoogleLogo } from '@redlink/components/atoms';
import { useValues } from '@redlink/assets/values';

export const GoogleLoginButton = memo(({ onSuccess, onFailure }) => {
  const { dictionary } = useLocale();
  const { constants } = useValues();
  return (
    <GoogleLogin
      clientId={constants.googleClientId}
      buttonText={dictionary.continueWithGoogle}
      {...{ onSuccess, onFailure }}
      cookiePolicy={'single_host_origin'}
      render={(renderProps) => (
        <Button
          variant="gray"
          title={dictionary.continueWithGoogle}
          icon={<IconGoogleLogo />}
          onPress={renderProps.onClick}
          disabled={renderProps.disabled}
        />
      )}
    />
  );
});
